import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Chart, registerables } from 'chart.js';
import { tap } from 'rxjs';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';
import { UtilisateursService } from 'src/app/modules/utilisateurs/services/utilisateurs.service';

Chart.register(...registerables);

@Component({
  selector: 'app-horsigui-stat',
  templateUrl: './horsigui-stat.component.html',
  styleUrls: ['./horsigui-stat.component.css'],
})
export class HorsiguiStatComponent implements OnInit {
  chart!: any;
  chart2!: any;
  homme: number[] = [];
  femme: number[] = [];

  hommes: number[] = [];
  femmes: number[] = [];
  cities: string[] = [];
  // cities: string[] = [
  //   'Dakar',
  //   'Diourbel',
  //   'Fatick',
  //   'Hors Sénégal',
  //   'Kaffrine',
  //   'Kaolack',
  //   'Kolda',
  //   'Kédougou',
  //   'Louga',
  //   'Matam',
  //   'Saint-Louis',
  //   'Sédhiou',
  //   'Tambacounda',
  //   'Thiès',
  //   'Ziguinchor',
  // ];
  countAdmis!: number;
  countNoAdmis!: number;
  cohorte: any = null;
  breadcrumbItems!: BreadcrumbItem[];

  constructor(
    private utilisaterService: UtilisateursService,
    private route: ActivatedRoute,
    private spinnerService: SpinnerServiceService
  ) { }

  ngOnInit(): void {
    // this.getSession();
    this.cohorte = sessionStorage.getItem('cohorte');
    this.route.params.subscribe((data: any) => {
      this.cohorte = data['cohortId'];
      this.generateGenderChart(this.cohorte);
      this.getAdmittedByCityAndSexe(this.cohorte);
      // console.log('cohorte recup 2############## :', this.cohorte);
    });
    this.breadcrumbItems = [
      { label: 'HORS SIGUI' },
      {
        label: `SESSION ${this.cohorte}`,
        url: `/dashboard/appels/candidaturesHS/${this.cohorte}`,
      },
      {
        label: 'STATISTIQUES',
        url: `/dashboard/appels/statistiquesHS/${this.cohorte}`,
      },
    ];
  }
  getSession() {
    this.cohorte = sessionStorage.getItem('cohorte');
    // console.log('cohorte recup 2 :', this.cohorte);
  }

  // ngAfterViewInit(): void {
  //   this.getAdmittedByCityAndSexe();
  //   this.generateGenderChart(this.cohorte);
  // }

  getAdmittedByCityAndSexe(cohorte: string) {
    this.utilisaterService.getAdmittedByCityAndGenderHSG(cohorte).subscribe({
      next: (stats) => {
        if (!stats || typeof stats !== 'object') {
          console.error('Données de stats invalides :', stats);
          return;
        }
        this.cities = Object.keys(stats);
        this.homme = [];
        this.femme = [];
        this.cities.forEach((city) => {
          const cityData = stats?.[city] || {};
          this.homme.push(cityData.Homme ?? 0);
          this.femme.push(cityData.Féminin ?? 0);
        });
        this.setDiagrams(
          this.cities,
          'canvasCityAndGender',
          this.homme,
          this.femme,
          'Repartition par region et par genre',

          {
            homme: 'rgb(14, 159, 110)',
            femme: 'rgb(240, 82, 82)',
          }
        );
      },
      error: (error) => {
        this.baseerror(error);
      },
    });
  }

  setDiagrams(
    fullLabels: string[],
    canvasName: string,
    maleData: number[],
    femaleData: number[],
    title: string,
    color: { homme: string; femme: string }
  ) {
    const canvas = document.getElementById(canvasName) as HTMLCanvasElement;
    const ctxIA = canvas.getContext('2d')
    const shortLabels = fullLabels.map(label => {
      const parts = label.split(/[\s-]/);
      if (parts.length === 1) {
        const consonants = label.replace(/[aeiouAEIOU]/g, '');
        return consonants.length >= 2
          ? (consonants.charAt(0) + consonants.charAt(1)).toUpperCase()
          : label.substring(0, 2).toUpperCase();
      }
      return parts.map(w => w.charAt(0).toUpperCase()).join('').substring(0, 3);
    });

    if (ctxIA) {
      this.chart = new Chart(ctxIA, {
        type: 'bar',
        data: {
          labels: shortLabels,
          datasets: [
            {
              label: 'Homme',
              data: maleData,
              backgroundColor: color.homme,
            },
            {
              label: 'Femme',
              data: femaleData,
              backgroundColor: color.femme,
            },
          ],
        },
        options: {
          plugins: {
            title: {
              display: true,
              text: title,
            },
            tooltip: {
              callbacks: {
                title: function (context) {
                  const index = context[0].dataIndex;
                  return fullLabels[index];
                },
              },
            },
          },
          responsive: true,
          interaction: {
            intersect: false,
          },
          scales: {
            x: { stacked: true },
            y: { stacked: true },
          },
        },
      });
    }
  }


  // Diagmm Repartition du nmbre dadmis par famille de métier et par genre

  generateGenderChart(cohorte: any) {
    this.spinnerService.showSpinner();
    this.utilisaterService.getCertificatedHorsSiguiStat(cohorte).subscribe({
      next: (data) => {
        this.spinnerService.hideSpinner();
        if (!data) {
          console.error('Données nulles ou non valides', data);
          return;
        }

        const maxLabelLength = 3;
        var label: any = [];
        var fullLabels: string[] = [];

        this.hommes = [];
        this.femmes = [];

        type EntryData = {
          [key: string]: number;
        };

        Object.entries(data as Record<string, EntryData>).map(
          ([name, item]) => {
            const safeName = name ?? '';
            fullLabels.push(safeName);

            const homme = item?.['Homme'] ?? 0;
            const femme = item?.['Féminin'] ?? 0;

            label.push(
              safeName.length > maxLabelLength
                ? safeName.slice(0, maxLabelLength) + '…'
                : safeName
            );
            this.hommes.push(homme);
            this.femmes.push(femme);
          }
        );
        // ✅ Attendre le rendu DOM (canvas) avant d’afficher le graphe
        setTimeout(() => {
          const canvas = document.getElementById(
            'canvasFamily'
          ) as HTMLCanvasElement;
          if (!canvas) {
            console.error("Canvas 'canvasFamily' introuvable !");
            return;
          }

          this.setGenderChart(
            fullLabels,
            label,
            'canvasFamily',
            this.hommes,
            this.femmes,
            "Répartition du nombre d'admis par certificat et par genre",
            {
              homme: 'rgba(75, 192, 192, 0.2)',
              femme: 'rgba(255, 99, 132, 0.2)',
            }
          );
        }, 0);
      },
      error: (error) => {
        this.spinnerService.hideSpinner();
        this.baseerror(error);
      },
    });
  }
  baseerror(error: any) {
    console.log(error);
    alert('Erreur de Recuperation des Données');
  }
  // Méthode pour dessiner le diagramme Rpartition du nombre d'admis par famille de métier et par genre
  setGenderChart(
    fullLabels: string[],
    label: string[],
    canvasName: string,
    maleData: number[],
    femaleData: number[],
    title: string,
    colors: { homme: string; femme: string }
  ) {
    const canvas = document.getElementById(canvasName) as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      console.error('Contexte 2D non trouvé pour le canvas', canvas);
    }
    if (ctx) {
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: label,
          datasets: [
            {
              label: 'Homme',
              data: maleData,
              backgroundColor: colors.homme,
              borderColor: 'rgb(54, 162, 235)',
              borderWidth: 1,
            },
            {
              label: 'Femme',
              data: femaleData,
              backgroundColor: colors.femme,
              borderColor: 'rgb(255, 99, 132)',
              borderWidth: 1,
            },
          ],
        },
        options: {
          plugins: {
            title: {
              display: true,
              text: title,
            },
            tooltip: {
              callbacks: {
                title: function (context) {
                  const index = context[0].dataIndex;
                  return fullLabels[index]; // label complet au survol
                },
              },
            },
          },
          responsive: true,
          interaction: {
            intersect: false,
          },
          scales: {
            x: {
              stacked: true,
            },
            y: {
              stacked: true,
            },
          },
        },
      });
    }
  }
}
